import { useEffect } from 'react';
import { Message } from '@meitu/saas-ui';
import { getFramework, useIdentity } from '@/framework';
import { useLocaleStore } from '@/i18n';
import { useIntelligentColorState } from '../states/intelligent-color-state';

export const useInit = () => {
    const { $t } = useLocaleStore();
    const editorIdentity = useIdentity();
    const framework = getFramework(editorIdentity);

    const isIntelligent = useIntelligentColorState()((state) => state.isIntelligent);

    // 控制隐藏、显示素材层
    useEffect(() => {
        if (!isIntelligent) return;

        // 禁用图层选中事件，取消激活图层
        framework.operate.disablePick();

        setTimeout(() => {
            const stageIndex = framework.stage.getActiveStageIndex();

            framework.operate.delActiveLayer();

            const layers = framework.getLayers(stageIndex);

            framework.stage.hideMaterial();

            // HACK: 当前的定义是只有主图和背景图层不属于素材层，同时一定会存在，这里先临时处理
            const hasMaterialLayer = layers.length > 2;

            if (hasMaterialLayer) {
                Message.info($t((v) => v.mainLayer.operate.messageInfo));
            }
        }, 0);

        return () => {
            framework.stage.showMaterial();
            // 恢复图层选中事件
            framework.operate.enablePick();
        };
    }, [isIntelligent]);
};
